import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 재고 현황 마스터(공급) — AnalysisController#getStockSupply(백엔드는
// factoryplan/analysis/stock-result/stock-outputs/supply). 크로스탭이 아니라 List<StockOutputPlanDto>
// 배열 자체(래핑 없음). 마스터-디테일 2그리드 화면의 마스터 쪽(fp-report-screen-guide.md §C).
const getStockSupply = (params) => fpApiUtil.postParams(`${ANALYSIS}/stock-result/stock-outputs/supply`, params);

// 재고 현황 상세(소비 내역) — AnalysisController#getStockConsumption(백엔드는
// factoryplan/analysis/stock-result/stock-outputs/consumption). 같은 DTO를 공유하되 마스터에서
// 선택한 stockCd 하나로 필터링된 소비 내역만 내려온다 — 마스터 행 클릭 시 재조회(§C).
const getStockConsumption = (params) => fpApiUtil.postParams(`${ANALYSIS}/stock-result/stock-outputs/consumption`, params);

const fpStockResultService = { getStockSupply, getStockConsumption };
export default fpStockResultService;
